// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3cf7d878","455":"b5580174","977":"bf13cec5"}[chunkId] + ".chunk.js";
};